var map = {
	"./symbol_0.png": 35089,
	"./symbol_1.png": 95144,
	"./symbol_2.png": 32003,
	"./symbol_3.png": 10426,
	"./symbol_4.png": 84725,
	"./symbol_5.png": 1836,
	"./symbol_6.png": 70311,
	"./symbol_7.png": 82622,
	"./symbol_8.png": 97865,
	"./symbol_9.png": 26688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3340;